// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_chess_pieces/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_chess_pieces: ModuleSchema = {
  "id": "core_chess_pieces",
  "uniqueId": "B3D_RKSCE",
  "createdAt": "2026-10-06T00:00:00Z",
  "updatedAt": "2026-10-28T14:57:47.765Z",
  "label": "Chess Pieces",
  "description": "core_chess_pieces parametric 3D model",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_CHESS01",
    "chess-pieces",
    "knight-king"
  ],
  "sliders": [
    {
      "key": "pieceType",
      "label": "Loại Con Cờ (0:Ngựa, 1:Vua, 2:Cả Hai)",
      "min": 0,
      "max": 2,
      "default": 2,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "thickness",
      "label": "Độ Dày Đùn Khối 3D (Thickness)",
      "min": 1,
      "max": 10,
      "default": 4,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "pieceScale",
      "label": "Tỉ Lệ Kích Thước (Piece Scale)",
      "min": 0.5,
      "max": 3,
      "default": 1.5,
      "step": 0.1,
      "unit": "x",
      "enabled": true,
      "visible": true
    },
    {
      "key": "spacing",
      "label": "Khoảng Cách 2 Con Cờ (Spacing)",
      "min": 10,
      "max": 50,
      "default": 25,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "knight_part",
      "label": "Con Ngựa 3D",
      "default": "#3B82F6",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "king_part",
      "label": "Con Vua 3D",
      "default": "#F97316",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "knight_piece",
      "label": "Con Cờ Ngựa Assembly",
      "name": "Con Cờ Ngựa Assembly",
      "color": "#3B82F6",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "knight_part",
          "label": "Con Ngựa 3D",
          "name": "Con Ngựa 3D",
          "groupId": 0,
          "colorKey": "knight_part",
          "defaultColor": "#3B82F6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "king_piece",
      "label": "Con Cờ Vua Assembly",
      "name": "Con Cờ Vua Assembly",
      "color": "#F97316",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "king_part",
          "label": "Con Vua 3D",
          "name": "Con Vua 3D",
          "groupId": 1,
          "colorKey": "king_part",
          "defaultColor": "#F97316",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Both Pieces Assembly"
    },
    {
      "id": "0",
      "label": "Download STL - Knight Piece"
    },
    {
      "id": "1",
      "label": "Download STL - King Piece"
    }
  ]
};
